module.exports = __webpack_public_path__ + "assets/img/in_(1).16abb24c.gif";